import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert, Card, Spinner, Image } from 'react-bootstrap';

const apiUrl = process.env.REACT_APP_API_URL;
const apiImg = process.env.REACT_APP_API_IMG;

/** Máscara BR sem espaço antes do hífen
 *  11 dígitos -> (62) 98417-0365
 *  10 dígitos -> (62) 3210-0365
 */
function maskBRPhone(v = '') {
  const d = String(v || '').replace(/\D/g, '').slice(0, 11);
  const ddd = d.slice(0, 2);
  let mid = '';
  let tail = '';

  if (d.length <= 2) {
    // só DDD
  } else if (d.length <= 6) {
    // digitando o início do número
    mid = d.slice(2);
  } else if (d.length <= 10) {
    // fixo (10): 4-4
    mid = d.slice(2, 6);
    tail = d.slice(6, 10);
  } else {
    // celular (11): 5-4
    mid = d.slice(2, 7);
    tail = d.slice(7, 11);
  }

  const right = mid + (tail ? `-${tail}` : '');
  return [ddd ? `(${ddd})` : '', right].filter(Boolean).join(' ');
}

const SorteioBrinde = () => {
  const [phone, setPhone] = useState('');
  const [sorteio, setSorteio] = useState('');
  const [resultado, setResultado] = useState(null);
  const [animando, setAnimando] = useState(false);
  const [carregando, setCarregando] = useState(false);

  const animar = (finalCode) =>
    new Promise((resolve) => {
      setAnimando(true);
      let contador = 0;
      const it = setInterval(() => {
        // gera sequência visual durante a animação
        setSorteio(String(Math.floor(1000 + Math.random() * 9000)).slice(0, 4));
        contador++;
        if (contador > 10) {
          clearInterval(it);
          setSorteio(finalCode);
          setAnimando(false);
          resolve();
        }
      }, 100);
    });

  const sortear = async () => {
    setResultado(null);

    // segurança básica: exige pelo menos DDD + começo de número
    const onlyDigits = phone.replace(/\D/g, '');
    if (onlyDigits.length < 10) {
      setResultado({ type: 'danger', message: 'Digite um número de celular válido.' });
      return;
    }

    try {
      setCarregando(true);

      const resp = await fetch(`${apiUrl}/sorteio/try`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone }) // backend normaliza
      });

      if (resp.status === 409) {
        const data = await resp.json();
        setSorteio(data?.last?.code || '----'); // mostra direto
        setResultado({
          type: 'info',
          message:
            'Você já participou hoje. Volte amanhã! ' +
            (data?.last
              ? `Último código: ${data.last.code} · Resultado: ${data.last.won ? 'Ganhou' : 'Não ganhou'}`
              : '')
        });
        return;
      }


      if (!resp.ok) {
        const err = await resp.json().catch(() => ({}));
        throw new Error(err?.message || 'Falha na tentativa');
      }

      const data = await resp.json();
      await animar(data.code); // anima só quando realmente sorteou agora
      setResultado(
        data.won
          ? { type: 'success', message: '🎉 Parabéns! Você ganhou um brinde exclusivo!' }
          : { type: 'warning', message: '😢 Que pena, não foi dessa vez. Tente novamente amanhã!' }
      );  

    } catch (e) {
      console.error(e);
      setResultado({ type: 'danger', message: 'Erro ao validar sua tentativa. Tente novamente mais tarde.' });
    } finally {
      setCarregando(false);
    }
  };

  const btnDisabled = animando || carregando;

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col md={6}>
          <Card className="p-4 text-center shadow">
            <div className="d-flex align-items-center justify-content-center gap-2 mb-3">
              {/* {apiImg && <Image src={apiImg} alt="logo" height={28} />} */}
              <h2 className="mb-4">🎁 Promoção Gigabyte Telecom</h2>
            </div>

            <Form onSubmit={(e) => { e.preventDefault(); sortear(); }}>
              <Form.Group className="text-start">
                <Form.Label>Celular</Form.Label>
                <Form.Control
                  type="tel"
                  inputMode="numeric"
                  autoComplete="tel"
                  placeholder="(62) 99999-9999"
                  value={phone}
                  onChange={(e) => setPhone(maskBRPhone(e.target.value))}
                  disabled={btnDisabled}
                />
              </Form.Group>

              <Button
                variant="primary"
                onClick={sortear}
                disabled={btnDisabled}
                className="mt-3"
              >
                {carregando ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Validando…
                  </>
                ) : 'Verificar se ganhei'}
              </Button>
            </Form>

            <div className="mt-4 display-4">
              {sorteio && [...sorteio].map((n, i) => (
                <span key={i} className="mx-1">{n}</span>
              ))}
            </div>

            {resultado && (
              <Alert variant={resultado.type} className="mt-4 mb-0">
                {resultado.message}
              </Alert>
            )}
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default SorteioBrinde;
